import React from "react";

import { Stack } from "@mui/material";

import { CommentItem } from "./CommentItem";
import { NewsComment } from "./types";
import { useCommentsTree } from "./useCommentsTree";

interface Props {
  comments: NewsComment[];
  onReply?: (commentId: string, text: string) => void;
  currentUserAvatarUrl?: string;
}

export const CommentsList: React.FC<Props> = ({ comments, onReply, currentUserAvatarUrl }) => {
  const { getTopLevelComments, getChildren } = useCommentsTree(comments);
  const topLevelComments = getTopLevelComments();

  if (topLevelComments.length === 0) {
    return null;
  }

  return (
    <Stack sx={{ gap: "10px" }}>
      {topLevelComments.map((comment) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          childComments={getChildren(comment.id)}
          onReply={onReply}
          getChildren={getChildren}
          currentUserAvatarUrl={currentUserAvatarUrl}
        />
      ))}
    </Stack>
  );
};
